<template>
  <div>
    <v-container fluid class="center-wrapper pa-0">
      <v-card class="main-card pa-0" max-width="900" width="100%">
        <div class="header-section">
          <div class="header-title">Pre Register Summary</div>
        </div>
        <v-card-text class="pa-6">
          <v-row dense class="info-card pa-4">
            <v-col cols="12" md="6">
              <div class="info-item">
                <span class="label">Visitor Name</span>
                <span class="value">{{ VisitorName }}</span>
              </div>
              <div class="info-item">
                <span class="label">Start Date</span>
                <span class="value">{{ ChangeFormatDate(StartDate) }}</span>
              </div>
              <div class="info-item">
                <span class="label">Invite Tenant</span>
                <span class="value">{{ InviteTenantName }}</span>
              </div>
              <div class="info-item">
                <span class="label">Remark</span>
                <span class="value">{{ Remark }}</span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="info-item">
                <span class="label">Email</span>
                <span class="value">{{ VisitorEmail }}</span>
              </div>
              <div class="info-item">
                <span class="label">Invitation Name</span>
                <span class="value">{{ InvitationName }}</span>
              </div>
              <div class="info-item">
                <span class="label">Expire Date</span>
                <span class="value">{{ ChangeFormatDate(EndDate) }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row justify="center" class="mt-10">
            <v-btn
              :disabled="ApproveStatus"
              class="btn-approve mr-4 text-capitalize"
              large
              @click="ApprovePreRegister()"
            >
              Approve
            </v-btn>

            <v-btn
              :disabled="ApproveStatus"
              class="btn-reject text-capitalize"
              large
              @click="RejectPreRegister()"
            >
              Reject
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "ApprovePreregister",
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      InviteID: null,
      VisitorName: "",
      VisitorEmail: "",
      InviteTenantName: "",
      InvitationName: "",
      StartDate: "",
      EndDate: "",
      Remark: "",
      ApproveStatus: false,
    };
  },

  async mounted() {
    let self = this;
    let url = window.location.href;
    if (url != "") {
      let url_text = url.split("/");
      await self.getDataPreRegisterForApprove(url_text[url_text.length - 1]);
    }
  },

  methods: {
    async getDataPreRegisterForApprove(uid) {
      let self = this;
      let temp = {
        invite_uid: uid,
      };
      self.LoadingDialog = true;
      await axios
        .post(`${self.url}PreRegister/getDataPreRegisterForApprove`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.InviteID = response.data.data.inviteID;
            self.VisitorName = response.data.data.guestInviteName;
            self.VisitorEmail = response.data.data.visitorEmail;
            self.InvitationName = response.data.data.invitationName;
            self.InviteTenantName = response.data.data.inviteTenantName;
            self.StartDate = response.data.data.startDateTime;
            self.EndDate = response.data.data.endDateTime;
            self.Remark = response.data.data.remark;
            self.ApproveStatus = response.data.data.approveStatus;
          }
        })
        .catch(function (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    ApprovePreRegister() {
      let self = this;
      let temp = {
        inviteId: self.InviteID,
        approve: true,
      };
      Swal.fire({
        text: "ยืนยันการ Approve ใช่หรือไม่ ?",
        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "#d33",
        confirmButtonText: "Approve",
        icon: "warning",
      }).then((result) => {
        if (result.isConfirmed) {
          self.LoadingDialog = true;
          axios
            .post(`${self.url}PreRegister/approveInvitePreRegister`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.getDataPreRegisterForApprove(self.InviteID);
              }
            })
            .catch(function (error) {
              const message =
                error?.response?.data?.message ||
                error?.message ||
                "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

              Swal.fire({
                icon: "warning",
                width: 900,
                text: message,
              });
            })
            .finally(() => {
              self.LoadingDialog = false;
            });
        }
      });
    },

    RejectPreRegister() {
      let self = this;
      let temp = {
        inviteId: self.InviteID,
        approve: false,
      };
      Swal.fire({
        text: "ยืนยันการ Reject ใช่หรือไม่ ?",
        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "#d33",
        confirmButtonText: "Reject",
        icon: "warning",
      }).then((result) => {
        if (result.isConfirmed) {
          self.LoadingDialog = true;
          axios
            .post(`${self.url}PreRegister/approveInvitePreRegister`, temp)
            .then(function (response) {
              if (response.data.status == 0) {
                Swal.fire({
                  icon: "success",
                  title: "Success",
                  showConfirmButton: false,
                  timer: 1500,
                });
              }
            })
            .catch(function (error) {
              const message =
                error?.response?.data?.message ||
                error?.message ||
                "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

              Swal.fire({
                icon: "warning",
                width: 900,
                text: message,
              });
            })
            .finally(() => {
              self.LoadingDialog = false;
            });
        }
      });
    },

    ChangeFormatDate(date) {
      if (!date) return null;
      var DateData = new Date(date);
      var hours = DateData.getHours();
      var minutes = DateData.getMinutes();
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes;
      return (
        DateData.getDate() +
        "/" +
        (DateData.getMonth() + 1) +
        "/" +
        DateData.getFullYear() +
        "  " +
        strTime
      );
    },
  },
};
</script>
<style scoped>
.center-wrapper {
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
}

.main-card {
  border-radius: 20px;
  overflow: hidden;
}

.header-section {
  background: linear-gradient(135deg, #1d3557, #457b9d);
  color: white;
  text-align: center;
  padding: 20px;
}

.header-title {
  font-size: 22px;
  font-weight: 700;
}

.section-title {
  text-align: center;
  font-size: 25px;
  font-weight: 700;
  color: #1d3557;
}

.info-card {
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.info-item {
  display: flex;
  flex-direction: column;
  margin-bottom: 14px;
}

.label {
  font-size: 16px;
  color: black;
}

.value {
  font-size: 16px;
  font-weight: 500;
  color: #203a5c;
}

.btn-approve {
  background: linear-gradient(135deg, #2ecc71, #27ae60);
  color: white;
  border-radius: 12px;
  width: 160px;
  font-weight: 600;
}
.btn-approve.v-btn--disabled,
.btn-reject.v-btn--disabled {
  background: #e0e0e0 !important;
  color: #9e9e9e !important;
  opacity: 0.8;
  box-shadow: none !important;
}

.btn-reject {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  color: white;
  border-radius: 12px;
  width: 160px;
  font-weight: 600;
}
</style>